// removed by extract-text-webpack-plugin
module.exports = {"destination":"_1CAF0_1C","service":"oKXQe_oK","table":"_3RQUs_3R"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Parcels/components/ParcelsList/ParcelsListTableDesktop/parcelsListTableDesktop.css
// module id = 732
// module chunks = 0